var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoughnutChart',{attrs:{"item-data":_vm.itemData,"label":"Languages","width":250}})
}
var staticRenderFns = []

export { render, staticRenderFns }